(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('webpageSettingEdit', {
        templateUrl: 'views/components/views/webpageSettingEdit/webpageSettingEdit.template.html?v=' + module.version,
        controllerAs: 'vm',
        bindings: {
            p2WebpageSettingKeyno: '<?',
            onSave: '&'
        },
        controller: ['$stateParams', 'stateService', 'webpageSettingEditService', 'layoutService', function ($stateParams, stateService, webpageSettingEditService, layoutService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let p2WebpageSettingKeyno = vm?.p2WebpageSettingKeyno ?? $stateParams.p2_webpage_setting_keyno;
            let tabletSize = layoutService.getMediaQueries().tablet;
            
            vm.model = {
                tabletSize: tabletSize,
                edit: {},
                lockedSave: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE CALL
            
            let loadEdit = function () {
                webpageSettingEditService.getEdit({ p2_webpage_setting_keyno: p2WebpageSettingKeyno }).then(function (info) {
                    angular.copy(info[0], vm.model.edit);
                });
            };

            // #endregion LOAD PROCEDURE CALL

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                webpageSettingEditService.saveObj(vm.model.edit).then(function () {
                    vm.model.lockedSave = false;

                    if (angular.isFunction(vm.onSave) && tabletSize.matches === true) {
                        vm.onSave();
                    } else {
                        stateService.back();
                    }
                }, function () {
                    vm.model.lockedSave = false;
                });
            };

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                //loadEdit();
            };

            // #endregion ON INIT FUNCTION

            // #region ON CHANGES FUNCTION

            vm.$onChanges = function (changes) {
                if (changes?.p2WebpageSettingKeyno?.currentValue) {
                    p2WebpageSettingKeyno = changes.p2WebpageSettingKeyno.currentValue;
                }

                if (p2WebpageSettingKeyno) loadEdit();
            };

            // #endregion ON CHANGES FUNCTION

        }]
    });
})();
